import { LeadingAgentInfo } from './leading-agent-info';

export default LeadingAgentInfo;
